import styled, { css } from 'styled-components';
import SliderSlick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { propCond } from '../utils/propCond';
import { always, equals } from 'ramda';

export const SLIDER_SELECTORS = {
  TRACK: '.slick-track',
  ITEM_OUTER_WRAPPER: '.slick-track > .slick-slide',
  ITEM_INNER_WRAPPER: '.slick-track > .slick.slide > div',
  ITEM: '.slick-track > .slick-slide > div > * ',
  FIRST_ITEM: '.slick-track > .slick-slide:first-child > div > * ',
  LAST_ITEM: '.slick-track > .slick-slide:last-child > div > * '
};

export const SLIDER_VARIANTS = {
  EQUAL_HEIGHT: 'EQUAL_HEIGHT',
};

export const getSliderSettings = (customSettings = {}) => ({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  variableWidth: true,
  ...customSettings,
});

const variantCond = propCond('variant');

export const Slider = styled(SliderSlick)`
  overflow-x: hidden;

  ${SLIDER_SELECTORS.ITEM} {
    width: ${({ itemWidth = 300 }) => itemWidth}px !important;
  }

  ${variantCond([
    [
      equals(SLIDER_VARIANTS.EQUAL_HEIGHT),
      always(css`
        ${SLIDER_SELECTORS.TRACK} {
          min-height: 100%;
          display: flex;
        }

        ${SLIDER_SELECTORS.ITEM_OUTER_WRAPPER} {
          display: flex;
          height: auto;
        }

        ${SLIDER_SELECTORS.ITEM} {
          height: 100%;
        }
      `),
    ],
  ])}
`;
